import store from "../store/store";
import { patientsActionTypes } from "./saga";
/**
 * @module patients saga
 */

/**
 * set ABDM Auth creds
 * @param {string} data
 */
export function abdmResetAbhaPassword(password, navigate) {
  store.dispatch({
    type: patientsActionTypes.RESET_ABHA_PASSWORD,
    payload: {
      password,
      navigate
    }
  });
}

/**
 * set ABDM Auth modes
 * @param {string} data
 */
export function setAuthModes(data) {
  store.dispatch({
    type: patientsActionTypes.SET_AUTH_MODES,
    payload: {
      data
    }
  });
}

/**
 * set ABDM Auth creds
 * @param {string} value
 * @param {string} authMode
 */
export function generateOtpForUpdate(value, authMode) {
  store.dispatch({
    type: patientsActionTypes.GENERATE_OTP_TO_UPDATE_PHONE_NUMBER_OR_EMAIL,
    payload: {
      value,
      authMode
    }
  });
}

/**
 * set ABDM Auth creds
 * @param {string} value
 * @param {string} authMode
 */
export function verifyOtpForUpdate(value, authMode, data, navigate) {
  store.dispatch({
    type: patientsActionTypes.VERIFY_OTP_TO_UPDATE_PHONE_NUMBER_OR_EMAIL,
    payload: {
      value,
      authMode,
      data,
      navigate
    }
  });
}
/**
 * clear un used healthId
 */
export function clearUnusedHealthId() {
  store.dispatch({
    type: patientsActionTypes.CLEAR_ABDM_UNUSED_HEALTH_ID
  });
}

/**
 * clear Linked profiles
 */
export function clearLinkedProfiles() {
  store.dispatch({
    type: patientsActionTypes.CLEAR_ABDM_LINKED_PROFILES
  });
}

/**
 * create patients profiles
 * @param {string} profileName
 */
export function createDemographic(profileName) {
  store.dispatch({
    type: patientsActionTypes.CREATE_PATIENTS_DEMOGRAPHIC,
    payload: {
      profileName
    }
  });
}
/**
 * add patients profiles
 * @param {object} data
 */
export function addPatientsDemographics(data) {
  store.dispatch({
    type: patientsActionTypes.ADD_PATIENTS_DEMOGRAPHICS,
    payload: data
  });
}
/**
 * add patients subscription
 * @param {object} data
 */
export function addPatientsSubscription(data) {
  store.dispatch({
    type: patientsActionTypes.ADD_PATIENTS_SUBSCRIPTION,
    payload: { data }
  });
}
/**
 * add patients subscription
 * @param {object} data
 */
export function addAutoApprovalPolicies(data) {
  store.dispatch({
    type: patientsActionTypes.ADD_AUTO_APPROVAL_POLICIES,
    payload: { data }
  });
}
/**
 * switch patients profile
 * @param {string} profileId
 */
export function switchPatientProfile(profileId) {
  store.dispatch({
    type: patientsActionTypes.SWITCH_PATIENT_PROFILE,
    payload: {
      profileId
    }
  });
}
/**
 * set transactionId
 * @param {string} transactionId
 */
export function setTransactionId(transactionId, phoneNumber) {
  store.dispatch({
    type: patientsActionTypes.PUT_TRANSACTION_ID,
    payload: {
      transactionId,
      phoneNumber
    }
  });
}
/**
 * send OTP for ABD auth
 * @param {string} authType
 * @param {string} method
 * @param {string} value
 */
export function sendOtpForAbdmAuthentication(auth, authType, method, value) {
  store.dispatch({
    type: patientsActionTypes.SEND_OTP_FOR_ABDM_AUTHENTICATION,
    payload: {
      auth,
      method,
      authType,
      value
    }
  });
}
/**
 * verify OTP for ABD auth
 * @param {string} auth
 * @param {string} method
 * @param {string} otp
 * @param {string} push
 */
export function verifyAbdmAuthenticationOtp(
  auth,
  method,
  otp,
  navigate,
  skipHealthInfo,
  healthId,
  phoneNumber,
  selectedAuthMethod
) {
  store.dispatch({
    type: patientsActionTypes.VERIFY_ABDM_AUTHENTICATION_OTP,
    payload: {
      auth,
      method,
      otp,
      navigate,
      skipHealthInfo,
      healthId,
      phoneNumber,
      selectedAuthMethod
    }
  });
}

export function confirmAbdmLogin(
  healthId,
  txnId,
  authMode,
  profileId,
  token,
  navigate,
  isRegister
) {
  store.dispatch({
    type: patientsActionTypes.CONFIRM_ABDM_LOGIN,
    payload: {
      healthId,
      txnId,
      authMode,
      profileId,
      token,
      navigate,
      isRegister
    }
  });
}

export function getModesForAbdmAuth(auth, method, value, yearOfBirth) {
  store.dispatch({
    type: patientsActionTypes.GET_MODES_FOR_ABDM_AUTH,
    payload: {
      auth,
      method,
      value,
      yearOfBirth
    }
  });
}

/**
 * create healthId
 * @param {string} data
 * @param {string} navigate
 */
export function createHealthId(data, navigate) {
  store.dispatch({
    type: patientsActionTypes.CREATE_HEALTH_ID,
    payload: { data, navigate }
  });
}

/**
 * get patients requests
 * @param {string} status
 * @param {string} limits
 * @param {object} options `{ silent }` — refresh without loading shimmer or error toast
 */
export function getPatientsRequests(status = "ALL", limits, options = {}) {
  store.dispatch({
    type: patientsActionTypes.GET_PATIENTS_REQUESTS,
    payload: {
      status,
      limits,
      silent: options.silent === true
    }
  });
}

export function getPatientsUpdatedRequests(data) {
  store.dispatch({
    type: patientsActionTypes.GET_PATIENTS_UPDATED_REQUESTS,
    payload: {
      data
    }
  });
}

/**
 * get patients care contexts
 */
export function getPatientsCareContexts() {
  store.dispatch({
    type: patientsActionTypes.GET_PATIENTS_CARE_CONTEXTS
  });
}

/**
 * get   Consent Artefact
 */
export function getPatientsConsentArtefact() {
  store.dispatch({
    type: patientsActionTypes.GET_PATIENTS_CONSENT_ARTEFACT
  });
}

/**
 * generate linking token
 */
export function generateNewLinkingToken(navigate) {
  store.dispatch({
    type: patientsActionTypes.GET_NEW_LINKING_TOKEN,
    payload: {
      navigate
    }
  });
}

export function logoutHealthId() {
  store.dispatch({
    type: patientsActionTypes.LOGOUT_HEALTH_ID
  });
}
/**
 * set linking token info
 * @param {object} linkingTokenData
 */
export function setLinkingTokenDetails(linkingTokenData) {
  store.dispatch({
    type: patientsActionTypes.LINKING_TOKEN_DETAILS,
    payload: {
      linkingTokenData
    }
  });
}
/**
 * accept patients request
 * @param {object} data
 */
export function acceptPatientsRequest(data) {
  switch (data.requestType) {
    case "consent":
      store.dispatch({
        type: patientsActionTypes.ACCEPT_CONSENT_REQUEST,
        payload: data
      });
      break;
    case "subscription":
      store.dispatch({
        type: patientsActionTypes.ACCEPT_SUBSCRIPTION_REQUEST,
        payload: data
      });
      break;
    case "lockerSetup":
      store.dispatch({
        type: patientsActionTypes.ACCEPT_LOCKER_REQUEST,
        payload: data
      });
      break;
    case "authorization":
      store.dispatch({
        type: patientsActionTypes.ACCEPT_AUTHORIZATION_REQUEST,
        payload: data
      });
      break;

    default:
      break;
  }
}

/**
 * deny patients request
 * @param {object} data
 */
export function denyPatientsRequest(data) {
  switch (data.requestType) {
    case "consent":
      store.dispatch({
        type: patientsActionTypes.DENY_CONSENT_REQUEST,
        payload: data
      });
      break;
    case "subscription":
      store.dispatch({
        type: patientsActionTypes.DENY_SUBSCRIPTION_REQUEST,
        payload: data
      });
      break;
    case "authorization":
      store.dispatch({
        type: patientsActionTypes.DENY_AUTHORIZATION_REQUEST,
        payload: data
      });
      break;

    default:
      break;
  }
}

/**
 * deny patients request
 * @param {object} data
 */
export function revokePermission(data) {
  switch (data.requestType) {
    case "consent":
      store.dispatch({
        type: patientsActionTypes.REVOKE_CONSENT_REQUEST,
        payload: data
      });
      break;

    case "authorization":
      store.dispatch({
        type: patientsActionTypes.REVOKE_AUTHORIZATION_REQUEST,
        payload: data
      });
      break;

    default:
      break;
  }
}
/**
 * health locker authorization
 */
export function healthLockerAuthorization() {
  store.dispatch({
    type: patientsActionTypes.HEALTH_LOCKER_AUTHORIZATION
  });
}

/**
 * revoke auto approval policy
 * @param {object} data
 */
export function disableAutoApprove(data) {
  store.dispatch({
    type: patientsActionTypes.DISABLE_AUTO_APPROVE,
    payload: data
  });
}

/**
 * create auto approval policy
 * @param {object} data
 */
export function createAutoApprove(data) {
  store.dispatch({
    type: patientsActionTypes.CREATE_AUTO_APPROVE,
    payload: data
  });
}

/**
 * enable auto approval policy
 * @param {object} data
 */
export function enableAutoApprove(data) {
  store.dispatch({
    type: patientsActionTypes.ENABLE_AUTO_APPROVE,
    payload: data
  });
}

/**
 * get health id information
 */
export function getHealthIdInformation() {
  store.dispatch({
    type: patientsActionTypes.GET_HEALTH_ID_INFORMATION
  });
}

/**
 * revoke auto approval policy
 * @param {object} data
 */
export function editProfile(data) {
  store.dispatch({
    type: patientsActionTypes.EDIT_PROFILE,
    payload: { data }
  });
}

export function saveEditProfile(data) {
  store.dispatch({
    type: patientsActionTypes.SAVE_EDIT_PROFILE,
    payload: data
  });
}

/**
 * set requests filter data
 * @param {string} filterBy
 * @param {string} profileId
 */
export function setRequestsFilterData(filterBy, id) {
  store.dispatch({
    type: patientsActionTypes.SET_REQUESTS_FILTER_DATA,
    payload: {
      filterBy,
      id
    }
  });
}

/**
 * link abha id number
 * @param {object} data
 */
export function linkHealthIdNumber(data, type, modal) {
  store.dispatch({
    type: patientsActionTypes.LINK_HEALTH_ID_NUMBER,
    payload: {
      data,
      type,
      modal
    }
  });
}

/**
 * Confirm unlink ABHA address from ABHA number
 * @param {string} healthId
 */
export function searchHealthIdAuthMode(abhaNumber) {
  store.dispatch({
    type: patientsActionTypes.SEARCH_HEALTH_ID_AUTH_MODE,
    payload: {
      abhaNumber
    }
  });
}

/**
 * Generate OTP for unlink ABHA address from ABHA number
 * @param {string} healthId
 * @param {string} mode
 */
export function generateAbhaAddressOtp(healthId, mode) {
  store.dispatch({
    type: patientsActionTypes.GENERATE_LINK_OR_UNLINK_ABHA_ADDRESS_OTP,
    payload: {
      healthId,
      mode
    }
  });
}

/**
 * Confirm unlink ABHA address from ABHA number
 * @param {string} transactionId
 * @param {string} otp
 * @param {string} mode
 */
export function confirmLinkOrUnLinkAbhaAddressOtp(
  transactionId,
  otp,
  mode,
  linkAbhaAddress,
  navigate
) {
  store.dispatch({
    type: patientsActionTypes.CONFIRM_LINK_OR_UNLINK_ABHA_ADDRESS,
    payload: {
      transactionId,
      otp,
      mode,
      linkAbhaAddress,
      navigate
    }
  });
}

/**
 * set selected linked facilities Hip id
 * @param {string} linkedFacilitiesId
 */
export function setSelectedLinkedFacility(linkedFacilityId) {
  store.dispatch({
    type: patientsActionTypes.SELECTED_LINKED_FACILITY,
    payload: {
      linkedFacilityId
    }
  });
}

/**
 * set active settings menu
 * @param {string} menu
 */
export function setActiveSettingsMenu(menu) {
  store.dispatch({
    type: patientsActionTypes.ACTIVE_SETTINGS_MENU,
    payload: {
      menu
    }
  });
}

/**
 * set agree consent to personal data
 */
export function setConsentToPersonalData(navigate) {
  store.dispatch({
    type: patientsActionTypes.SET_CONSENT_TO_PERSONAL_DATA,
    payload: {
      navigate
    }
  });
}

export function clearShowSuccess() {
  store.dispatch({
    type: patientsActionTypes.CLEAR_SHOW_SUCCESS
  });
}

export function changePhoneNumber(shouldChange, navigate) {
  store.dispatch({
    type: patientsActionTypes.CHANGE_PHONE_NUMBER,
    payload: {
      shouldChange,
      navigate
    }
  });
}
